import { handleStatus500 } from 'api/Utility/HandleStatus500'
import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'

export const setBlockedFlag = async (id: string, blocked: boolean) => {
  const axios = AxiosInitializer({ token: getToken() })

  try {
    const blockURL = `/site_users/${id}/block`
    const unblockURL = `/site_users/${id}/unblock`

    try {
      const response = blocked
        ? await axios.patch(blockURL)
        : await axios.patch(unblockURL)

      return { blocked: response.data.data.blocked, ...response }
    } catch (error: any) {
      return { status: error.response.status }
    }
  } catch (error) {
    return handleStatus500(error)
  }
}
